<div class="search-cars-wrapper" id="div_search-cars-wrapper_6722921b">
  <div Class="filter-container" id="div_33cdb7f6">
    <div class="filter-top" id="div_filter-top_e7387342">
      <app-dropdown-filter
        [label]="'Product - STCC#'"
        [value]="activeStcc"
        [options]="stccOptions$"
        [displayProperty]="'description_stcc'"
        (selectionEmmiter)="selectedStcc($event)"
        [displayAs]="'dropdown'"
        [required]="true"
      ></app-dropdown-filter>
      <div class="filter-top-padding" id="div_filter-top-padding_1bcde1c0">
        <div
          *ngIf="!!activeStcc && activeStcc.stcc === 'Other'"
          id="div_ea5a2322"
        >
          <app-dropdown-filter
            [label]="'Product Name'"
            [value]="productName"
            (selectionEmmiter)="selectedProductName($event)"
            [displayAs]="'input'"
            [required]="true"
          ></app-dropdown-filter>
        </div>
      </div>
      <app-dropdown-filter
        [label]="'Railcar Type'"
        [value]="this.filterState.CarType.obj"
        [options]="carFilterObj.values"
        (selectionEmmiter)="selectionReciever($event)"
        [displayProperty]="'dropdownDisplay'"
        [filter]="carFilterObj"
        [filterContent]="false"
        [required]="true"
      ></app-dropdown-filter>
    </div>
    <div
      class="filter-bottom"
      *ngIf="!!filterState.CarType.values"
      id="div_filter-bottom_8690b8c9"
    >
      <ng-container
        *ngFor="let filter of filters; let i = index"
        id="ng-container_4d55a606"
      >
        <div
          *ngIf="
            filter.displayWhen === undefined || filter.displayWhen.isVisible
          "
          class="car-type-filter"
          [ngClass]="{ 'filter-padding': !filter.subtitle }"
          id="div_car-type-filter_a9a9866d"
        >
          <div
            class="filter-header"
            [ngClass]="{ 'header-subtitle': !!filter.subtitle }"
            (click)="toggleFilterOpen(i)"
            id="div_filter-header_2cf90669"
          >
            <span id="span_ed5d365b"
              >{{ filter.title
              }}<i *ngIf="!!filter.subtitle" id="i_2d63d317"
                >&nbsp;&nbsp;{{ filter.subtitle | titlecase }}</i
              ></span
            >
            <ng-container *ngIf="!filter.alwaysOpen" id="ng-container_35e55b17">
              <div
                class="triangle"
                [ngClass]="filter.open ? 'up' : 'down'"
                *ngIf="filter.displayAs !== 'dropdown' || !filter.open"
                id="div_triangle_53ab25b7"
              ></div>
            </ng-container>
          </div>
          <div
            class="filter-body"
            *ngIf="filter.open"
            [ngSwitch]="filter.displayAs"
            id="div_filter-body_c72fe4c2"
          >
            <ng-container *ngSwitchCase="'range'" id="ng-container_5daa3912">
              <div class="range-wrapper" id="div_range-wrapper_2a4388c0">
                <app-dropdown-filter
                  style="flex-grow: 1"
                  [label]="'MIN'"
                  [options]="filter.values"
                  [value]="filter.values[0]"
                  (selectionEmmiter)="selectionReciever($event)"
                  [filter]="filter"
                  [styleClass]="'grey'"
                ></app-dropdown-filter>
                <app-dropdown-filter
                  style="flex-grow: 1"
                  [label]="'MAX'"
                  [options]="filter.values"
                  [value]="filter.values[filter.values.length - 1]"
                  (selectionEmmiter)="selectionReciever($event)"
                  [filter]="filter"
                  [styleClass]="'grey'"
                ></app-dropdown-filter>
              </div>
            </ng-container>
            <ng-container
              *ngSwitchCase="'multiselect'"
              id="ng-container_03d869bb"
            >
              <app-multiselect-filter
                [label]="filter.title"
                (selectionEmmiter)="selectionReciever($event)"
                [filter]="filter"
                [styleClass]="'grey'"
              ></app-multiselect-filter>
            </ng-container>
            <ng-container *ngSwitchCase="'checkbox'" id="ng-container_895ee0cb">
              <app-checkbox-filter
                [filter]="filter"
                (selectionEmmiter)="selectionReciever($event)"
                [selected]="
                  !!filterState[filter.field]
                    ? filterState[filter.field].values
                    : []
                "
              ></app-checkbox-filter>
            </ng-container>
            <ng-container *ngSwitchCase="'location'" id="ng-container_54f09353">
              <app-location-filter
                [options]="filter.values || []"
                [filter]="filter"
                (selectionEmmiter)="selectionReciever($event)"
              ></app-location-filter>
            </ng-container>
            <ng-container *ngSwitchDefault id="ng-container_2feced90">
              <div *ngFor="let category of filter.values" id="div_354950eb">
                <span id="span_0ccdde3f">{{ category }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <div class="filter-btn" id="div_filter-btn_d2d1cf04">
        <div
          (click)="filterAction()"
          class="filter-button-apply"
          id="div_filter-button-apply_4b9df4e1"
        >
          <span class="filter-btn-txt" id="span_filter-btn-txt_6bd0ad63"
            >Apply</span
          >
        </div>
      </div>
    </div>
  </div>
  <app-display-segment
    [displayedCars]="displayedCars"
    [activeStcc]="activeStcc"
    [CarType]="filterState.CarType"
    [productName]="productName"
    [cardAttrList]="cardAttrList"
    [detailAttrList]="detailAttrList"
    [matchCt]="matchCt"
    [banner]="banner"
    (disableBanner)="disableBanner()"
    (displayFilter)="displayFilter()"
  ></app-display-segment>
</div>
<p-dialog
  [(visible)]="loading"
  [draggable]="false"
  [showHeader]="false"
  [focusTrap]="false"
  position="top"
  maskStyleClass="loading-dialog"
  id="p-dialog_13cd2b7e"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    id="p-progressSpinner_47dba2ca"
  ></p-progressSpinner>
</p-dialog>

<!-- <div class="progress-spinner" *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
</div> -->

<!-- Mobile View Filter -->
<p-dialog
  id="filter"
  [(visible)]="hildfilter"
  [closable]="true"
  [modal]="true"
  [style]="{ width: '100vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  header="Filter"
>
  <div
    [ngClass]="hildfilter ? 'filter-container-mobile' : 'filter-container'"
    id="div_a471aab2"
  >
    <div class="filter-top" id="div_filter-top_0b0a0962">
      <app-dropdown-filter
        [label]="'Product - STCC#'"
        [value]="activeStcc"
        [options]="stccOptions$"
        [displayProperty]="'description_stcc'"
        (selectionEmmiter)="selectedStcc($event)"
        [displayAs]="'dropdown'"
        [required]="true"
      ></app-dropdown-filter>
      <div class="filter-top-padding" id="div_filter-top-padding_e9c54b60">
        <div
          *ngIf="!!activeStcc && activeStcc.stcc === 'Other'"
          id="div_fc8c88ba"
        >
          <app-dropdown-filter
            [label]="'Product Name'"
            [value]="productName"
            (selectionEmmiter)="selectedProductName($event)"
            [displayAs]="'input'"
            [required]="true"
          ></app-dropdown-filter>
        </div>
      </div>
      <app-dropdown-filter
        [label]="'Railcar Type'"
        [value]="this.filterState.CarType.obj"
        [options]="carFilterObj.values"
        (selectionEmmiter)="selectionReciever($event)"
        [displayProperty]="'dropdownDisplay'"
        [filter]="carFilterObj"
        [filterContent]="false"
        [required]="true"
      ></app-dropdown-filter>
    </div>
    <div
      class="filter-bottom"
      *ngIf="!!filterState.CarType.values"
      id="div_filter-bottom_f0ad1e4a"
    >
      <ng-container
        *ngFor="let filter of filters; let i = index"
        id="ng-container_7d43fb94"
      >
        <div
          *ngIf="
            filter.displayWhen === undefined || filter.displayWhen.isVisible
          "
          class="car-type-filter"
          [ngClass]="{ 'filter-padding': !filter.subtitle }"
          id="div_car-type-filter_382f3822"
        >
          <div
            class="filter-header"
            [ngClass]="{ 'header-subtitle': !!filter.subtitle }"
            (click)="toggleFilterOpen(i)"
            id="div_filter-header_ca19d397"
          >
            <span id="span_92005f6f"
              >{{ filter.title
              }}<i *ngIf="!!filter.subtitle" id="i_ee6f3455"
                >&nbsp;&nbsp;{{ filter.subtitle | titlecase }}</i
              ></span
            >
            <ng-container *ngIf="!filter.alwaysOpen" id="ng-container_7fbe4608">
              <div
                class="triangle"
                [ngClass]="filter.open ? 'up' : 'down'"
                *ngIf="filter.displayAs !== 'dropdown' || !filter.open"
                id="div_triangle_172d9307"
              ></div>
            </ng-container>
          </div>
          <div
            class="filter-body"
            *ngIf="filter.open"
            [ngSwitch]="filter.displayAs"
            id="div_filter-body_03c56825"
          >
            <ng-container *ngSwitchCase="'range'" id="ng-container_c2502206">
              <div class="range-wrapper" id="div_range-wrapper_6c78a25b">
                <app-dropdown-filter
                  style="flex-grow: 1"
                  [label]="'MIN'"
                  [options]="filter.values"
                  [value]="filter.values[0]"
                  (selectionEmmiter)="selectionReciever($event)"
                  [filter]="filter"
                  [styleClass]="'grey'"
                ></app-dropdown-filter>
                <app-dropdown-filter
                  style="flex-grow: 1"
                  [label]="'MAX'"
                  [options]="filter.values"
                  [value]="filter.values[filter.values.length - 1]"
                  (selectionEmmiter)="selectionReciever($event)"
                  [filter]="filter"
                  [styleClass]="'grey'"
                ></app-dropdown-filter>
              </div>
            </ng-container>
            <ng-container
              *ngSwitchCase="'multiselect'"
              id="ng-container_ded7f183"
            >
              <app-multiselect-filter
                [label]="filter.title"
                (selectionEmmiter)="selectionReciever($event)"
                [filter]="filter"
                [styleClass]="'grey'"
              ></app-multiselect-filter>
            </ng-container>
            <ng-container *ngSwitchCase="'checkbox'" id="ng-container_48707b34">
              <app-checkbox-filter
                [filter]="filter"
                (selectionEmmiter)="selectionReciever($event)"
                [selected]="
                  !!filterState[filter.field]
                    ? filterState[filter.field].values
                    : []
                "
              ></app-checkbox-filter>
            </ng-container>
            <ng-container *ngSwitchCase="'location'" id="ng-container_a98ca072">
              <app-location-filter
                [options]="filter.values || []"
                [filter]="filter"
                (selectionEmmiter)="selectionReciever($event)"
              ></app-location-filter>
            </ng-container>
            <ng-container *ngSwitchDefault id="ng-container_227d7d02">
              <div *ngFor="let category of filter.values" id="div_0e742bf2">
                <span id="span_cf110673">{{ category }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <div class="filter-btn" id="div_filter-btn_715b2310">
        <div
          (click)="filterAction()"
          [ngClass]="
            activeStcc ? 'filter-button-apply' : 'filter-button-inactive'
          "
          id="div_c1a2bb63"
        >
          <span class="filter-btn-txt" id="span_filter-btn-txt_4f6603d1"
            >Apply</span
          >
        </div>
      </div>
    </div>
  </div>
</p-dialog>
